import Breadcrumb from "components/Common/Breadcrumb2"
import PropTypes from "prop-types"
import React from "react"
import { Col, Container, Row } from "reactstrap"

import { withTranslation } from "react-i18next"
import noProfiles from "../../assets/images/noProfile.svg"

const LandingPage = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Erro no cadastro de permissões")}
            breadcrumbItems={[]}
          />
          <Row>
            <Col>
              <Row>
                <Col lg="12">
                  <div className="text-center mb-5">
                    <h4 className="text-uppercase">
                      Por favor contate seu administrador.
                    </h4>
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col md="8" xl="6">
                  <div>
                    <img src={noProfiles} alt="" className="img-fluid" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

LandingPage.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(LandingPage)
